export default __webpack_public_path__ + "static/media/alsa.e7e751ef.svg";